import { CourseTabData, CourseTabGroup, hasSubtabs } from "@vixi/types";
import { findCourseTab } from "./find";
import { FindReturnType } from "@vixi/types";

export function getCourseTab(
  tabGroup: CourseTabGroup,
  path: (number | ((tab: CourseTabData) => boolean))[],
): FindReturnType<CourseTabData, number> | null {
  if (path.length === 0) {
    return {
      value: null,
      index: -1,
    };
  }

  let res: FindReturnType<CourseTabData, number> | null = null;
  const searchItem = path[0];
  const nextPath = path.slice(1);

  if (typeof searchItem === "function") {
    res = findCourseTab(tabGroup, searchItem);
  } else {
    const index = searchItem;
    if (index < 0 || index >= tabGroup.tabs.length) {
      return null;
    }
    res = {
      value: tabGroup.tabs[index],
      index,
      path: [index],
    };
  }

  // Path is an array, traverse the tab structure recursively

  if (nextPath.length === 0) {
    return res;
  }

  if (res && res.value && hasSubtabs(res.value)) {
    const nextRes = getCourseTab(res.value.tabList, nextPath);
    if (!nextRes) return null;

    return {
      ...nextRes,
      path: [res.index, ...(nextRes.path ?? [])],
    };
  }

  return null;
}
